import { Controller } from "stimulus";

export default class extends Controller {
  toggle(event) {
    var isRestricted = this.data.get("restricted") === "true";
    var warning = document.getElementById("shop-only-publish-warning");
    if (event.target.checked && isRestricted) {
      event.target.checked = false;
      if (warning) warning.classList.remove("hidden");
    } else {
      if (warning) warning.classList.add("hidden");
    }
  }
}
